import { render, staticRenderFns } from "./registerPage.vue?vue&type=template&id=a5076fa0&"
import script from "./registerPage.vue?vue&type=script&lang=ts&"
export * from "./registerPage.vue?vue&type=script&lang=ts&"
import style0 from "./registerPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports